import { ActionStandard } from 'flux-action-class'

export abstract class AppAction<Payload = undefined, Meta = undefined> extends ActionStandard<Payload, Meta> {
	protected static readonly prefix = 'salary:'
}